import {NgModule} from '@angular/core';
import {ElementRulerDirective} from './element-ruler.directive';

@NgModule({
    declarations: [
        ElementRulerDirective
    ],
    exports: [
        ElementRulerDirective
    ]
})
export class ElementRulerModule {}
